import { isAuthenticated } from "@/store/authStore";

export function canFetchConfigOrProfile(pathname: string) {
    const excluded = ["/login", "/register", "/forgot-password", "/reset-password"];

    if (excluded.includes(pathname)) {
        return false;
    }

    return isAuthenticated();
}

export function getQueryParams(params: Record<string, any>) {
    const query = new URLSearchParams();

    Object.keys(params).forEach((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
            value.forEach((val) => {
                query.append(key, val);
            });
        } else {
            if (value !== null && value !== undefined) {
                query.append(key, value);
            }
        }
    });

    return query;
}
